<template>
  <v-dialog v-model="dialog" persistent max-width="900">
    <v-card min-height="720">
      <v-card-title style="overflow: hidden">
        <v-row>
          <v-col
            cols="10"
            class="pr-0"
            style="text-align: center; padding-left: 20%"
          >
            <span class="text-333 font-18 w-600">แบบฟอร์มเยี่ยมบ้าน</span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="2" class="pl-0" style="text-align: end">
            <v-btn @click="closeDialog()" icon color="#00A99D">
              <v-icon class="font-18">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <v-row class="mt-2 px-3">
          <v-col
            cols="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            class="card-search pa-2"
          >
            <v-text-field
              v-model="search"
              class="card-search"
              label="ค้นหาแบบฟอร์ม"
              hint="กรอกคำค้นหา แล้วกด Enter เพื่อค้นหา"
              hide-details="auto"
              dense
              solo
              append-icon="mdi-magnify"
              clearable
              color="#00A99D"
              @click:clear="(search = ''), getHomeVisitForm()"
              @click:append="getHomeVisitForm()"
              @keypress.enter="getHomeVisitForm"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pt-0">
          <v-col cols="12" class="pb-0">
            <v-row class="pb-0" justify="center">
              <v-col cols="auto">
                <span class="font-16 text-00A99D w-600"
                  >เอกสารทั้งหมด {{ total }} รายการ</span
                >
              </v-col>
              <v-divider
                style="align-self: center"
                class="mr-3"
                color="#00A99D"
              ></v-divider>
            </v-row>
          </v-col>
        </v-row>
        <!-- ตาราง -->
        <v-row>
          <v-col cols="12" class="py-0">
            <v-data-table
              hide-default-header
              :headers="headersTable"
              :items="listForm"
              hide-default-footer
              :loading="loading"
              loading-text="กำลังโหลดข้อมูล"
              disable-sort
            >
              <template v-slot:no-data>
                <span class="font-16">ไม่พบข้อมูล</span>
              </template>

              <template v-slot:progress>
                <v-progress-linear
                  indeterminate
                  height="3px"
                  color="#00A99D"
                  class="mx-0"
                ></v-progress-linear>
              </template>

              <template v-slot:[`item.form_name`]="{ item }">
                <v-row style="align-items: center">
                  <Doc
                    :class="
                      display_vuetify == 'xs'
                        ? 'mx-1 icon-image'
                        : 'mx-5 icon-image'
                    "
                  />
                  <span
                    :class="
                      display_vuetify == 'xs'
                        ? 'font-14 w-500 text-333333'
                        : 'font-16 w-500 text-333333'
                    "
                    >{{ item.form_name }}</span
                  >
                </v-row>
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <v-tooltip v-if="select_status == 'ready'" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="#00A99D"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      fab
                      text
                      small
                      @click="select(item)"
                    >
                      <v-icon size="30">mdi-file-document-check-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>เลือกเอกสาร</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="#00A99D"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      fab
                      text
                      small
                      @click="selectForm(item)"
                      class="mx-3"
                    >
                      <v-icon size="30">mdi-file-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>ตัวอย่างเอกสาร</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" class="py-0" v-show="listForm.length > limit">
            <Pagination
              class="mt-2"
              :totals="total"
              :isPage="page"
              @page="changePage"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- <v-card-actions>
        <v-row justify="center" align="center" class="ma-0">
          <v-col cols="12" lg="6" md="6" sm="6">
            <v-btn outlined block depressed color="#00A99D" rounded @click="closeDialog()">
              <span class="text-00A99D">ยกเลิก</span>
            </v-btn>
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="6">
            <v-btn block depressed color="#00A99D" rounded @click="confirm(patientName)">
              <span class="text-white">ตกลง</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions> -->
    </v-card>
    <FormDisabledPerson ref="formDisabledPerson" @close="openHomeVisit" />
    <FormElderlyPerson ref="formElderlyPerson" @close="openHomeVisit" />
    <RegisterDialog ref="RegisterDialog" @close="openHomeVisit" />
  </v-dialog>
</template>

<script>
import moment from "moment";
import { Pagination } from "@/components/pagination";
import Doc from "@/assets/icon/Doc.vue";
import FormDisabledPerson from "@/views/HomeVisit/FormHomeVisit/FormDisabledPerson.vue";
import FormElderlyPerson from "@/views/HomeVisit/FormHomeVisit/FormElderlyPerson.vue";
// import RegisterDialog from "@/views/HomeVisit/RegisterDialog.vue"
import RegisterDialog from "../RegisterDialog.vue";

export default {
  components: {
    Doc,
    FormDisabledPerson,
    FormElderlyPerson,
    RegisterDialog,
    Pagination,
  },
  data() {
    return {
      dialog: false,
      staffName: "คุณ " + sessionStorage.getItem("accountName"),
      patientName: "",
      template_id: "",
      appointment_id: "",
      userqr_id: "",
      patientList: [],
      rule_select: [(v) => !!v || "กรุณาเลือกผู้รับบริการ"],
      form: "",
      role_name: sessionStorage.getItem("role_name"),
      loading: false,
      search: "",
      select_status: "ready",
      page: 1,
      limit: 5,
      total: 0,
      listForm: [],
      headersTable: [
        {
          text: "ชื่อไฟล์",
          align: "start",
          value: "form_name",
          width: "50%",
        },
        {
          text: "Action",
          align: "end",
          value: "action",
          width: "5%",
        },
      ],
    };
  },
  methods: {
    display_vuetify() {
      return this.$vuetify.breakpoint.name;
    },
    async openDialog(item, type) {
      console.log("item : ", item);
      console.log("type : ", type);

      this.staffName = "คุณ " + sessionStorage.getItem("accountName")
      this.patientName = `${item.account_title_th} ${item.first_name_th} ${item.last_name_th}`
      this.template_id = item.template_id
      this.appointment_id = item.appointment_id
      this.userqr_id = item.userqr_id
      await this.getHomeVisitForm();
      this.dialog = true;
    },
    closeDialog() {
      this.form = "";
      this.patientName = "";
      this.dialog = false;
    },
    async getHomeVisitForm() {
      console.log("getHomeVisitForm");
      this.loading = true;
      this.listForm = [];
      try {
        var params = new URLSearchParams();
        params.append("limit", this.limit);
        params.append("page", this.page || 1);
        params.append("biz_id", sessionStorage.getItem("biz_id"));
        params.append("appointment_id", this.appointment_id);
        params.append("search", this.search);
        // params.append('status', this.select_status)

        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/get_form_home_visits_v2?${params}`,
          )
          .then((res) => {
            console.log("res", res);
            if (res.data.result == "success") {
              setTimeout(() => {
                if (res.data.data.length !== 0 && res.data.count !== 0) {
                  this.listForm = res.data.data;
                  this.total = res.data.count;
                } else {
                  this.listForm = [];
                  this.total = 0;
                }
                this.loading = false;
              }, 1000);
            }
          });
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    openHomeVisit() {
      this.$router.push({ name: "HomeVisit" });
    },
    async getPatient() {
      try {
        var params = new URLSearchParams();
        params.append("biz_id", sessionStorage.getItem("biz_id"));

        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/get_data_user?${params}`,
          )
          .then(async (res) => {
            // console.log('res1111111111111111111111',res);
            if (res.data.result == "success") {
              if (res.data.data.length !== 0) {
                this.patientList = res.data.data;
              } else {
                this.patientList = [];
              }
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    showDate(item) {
      if (
        item.slot_date !== "" &&
        item.slot_date !== null &&
        item.slot_date !== undefined
      ) {
        var year1 = "";
        var year2 = "";
        year1 = moment(item.slot_date).locale("th").format("YYYY");
        year2 = (parseInt(year1) + 543).toString();

        if (
          item.start_time !== "" &&
          item.start_time !== null &&
          item.start_time !== undefined &&
          item.end_time !== "" &&
          item.end_time !== null &&
          item.end_time !== undefined
        ) {
          return (
            "วันนัดหมาย : " +
            moment(item.slot_date)
              .locale("th")
              .format("DD/MM/" + year2) +
            " เวลา " +
            item.start_time +
            " - " +
            item.end_time +
            " น."
          );
        } else if (
          item.start_time !== "" &&
          item.start_time !== null &&
          item.start_time !== undefined &&
          (item.end_time == "" ||
            item.end_time == null ||
            item.end_time == undefined)
        ) {
          return (
            "วันนัดหมาย : " +
            moment(item.slot_date)
              .locale("th")
              .format("DD/MM/" + year2) +
            " เวลา " +
            item.start_time
          );
        } else if (
          (item.start_time == "" ||
            item.start_time == null ||
            item.start_time == undefined) &&
          item.end_time !== "" &&
          item.end_time !== null &&
          item.end_time !== undefined
        ) {
          return (
            "วันนัดหมาย : " +
            moment(item.slot_date)
              .locale("th")
              .format("DD/MM/" + year2) +
            " เวลา " +
            item.end_time
          );
        } else {
          return (
            "วันนัดหมาย : " +
            moment(item.slot_date)
              .locale("th")
              .format("DD/MM/" + year2)
          );
        }
      } else {
        return "วันนัดหมาย : ไม่ระบุ";
      }
    },
    select(item) {
      console.log("select", item);
      this.$swal({
        title:
          "<span style='color: #000000;font-size: 20px;font-family: Sarabun;font-weight: 700;'>ท่านต้องการยืนยันใช้แบบฟอร์มนี้ใช่หรือไม่ ?</span>",
        html: `
        <span style='color: #000000;font-size: 16px;font-family: Sarabun;font-weight: 500; '>" ${item.form_name} "</span><br><br>
        <span style='color: #000000;font-size: 14px;font-family: Sarabun;font-weight: 700;'>ผู้รับบริการ: </span>
        <span style='color: #000000;font-size: 14px;font-family: Sarabun;font-weight: 500;'>${this.patientName}</span><br>
        <span style='color: #000000;font-size: 14px;font-family: Sarabun;font-weight: 700;'>เจ้าหน้าที่: </span>
        <span style='color: #000000;font-size: 14px;font-family: Sarabun;font-weight: 500;'>${this.staffName}</span><br>`,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText:
          "<span style='font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
        cancelButtonColor: "#F5222D",
        showConfirmButton: true,
        confirmButtonText:
          "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            let body = {
              biz_id: sessionStorage.biz_id,
              appointment_id: this.appointment_id,
              form_id: item.form_id,
              form_name: item.form_name,
              userqr_id: this.userqr_id,
              select_by: sessionStorage.oneId,
              copies_status: false,
            };

            await this.axios
              .post(
                `${process.env.VUE_APP_BACKEND_URL}/v1/select_form_home_visit`,
                body
              )
              .then((res) => {
                // console.log("res.data.data",res.data.data);
                if (res.data.result == "success") {
                  this.$swal({
                    title:
                      "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
                    icon: "success",
                    showConfirmButton: false,
                    confirmButtonText: "ปิด",
                    confirmButtonColor: "#00A99D",
                    timer: 2000,
                    timerProgressBar: true,
                  }).then(() => {
                    this.closeDialog();
                    this.$emit("close");

                    if (
                      "form_id" in res.data.data &&
                      "form_name" in res.data.data
                    ) {
                      if (
                        res.data.data.form_name == "แบบฟอร์มเยี่ยมบ้านผู้พิการ"
                      ) {
                        this.$emit("viewForm", {
                          value: {
                            form_id: res.data.data.form_id,
                            form_name: "แบบฟอร์มเยี่ยมบ้านผู้พิการ",
                            template_id: res.data.data.template_id
                          },
                          item: res.data.data,
                          type: "register",
                        });
                      } else if (
                        res.data.data.form_name ==
                        "แบบฟอร์มเยี่ยมบ้านผู้สูงอายุ"
                      ) {
                        this.$emit("viewForm", {
                          value: {
                            form_id: res.data.data.form_id,
                            form_name: "แบบฟอร์มเยี่ยมบ้านผู้สูงอายุ",
                            template_id: res.data.data.template_id
                          },
                          item: res.data.data,
                          type: "register",
                        });
                      } else if (
                        res.data.data.form_name ==
                        "แบบฟอร์มเยี่ยมบ้านคลินิกอบอุ่น"
                      ) {
                        this.$emit("viewForm", {
                          value: {
                            form_id: res.data.data.form_id,
                            form_name: "แบบฟอร์มเยี่ยมบ้านคลินิกอบอุ่น",
                            template_id: res.data.data.template_id
                          },
                          item: res.data.data,
                          type: "register",
                        });
                      }
                    }
                  });
                } else {
                  this.$swal({
                    title:
                      "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลไม่สำเร็จ</span>",
                    icon: "error",
                    showCloseButton: false,
                    showConfirmButton: false,
                    background: "white",
                    timer: 3000,
                  });
                }
              });
          } catch (error) {
            console.log("error", error);
          }
        }
      });
    },
    selectForm(item) {
      // console.log("selectForm", item);
      if (item.form_name == "แบบฟอร์มเยี่ยมบ้านผู้พิการ") {
        this.$emit("viewForm", {
          value: {
            form_name: "แบบฟอร์มเยี่ยมบ้านผู้พิการ"
          },
          item: item,
          type: "see",
        });
      } else if (item.form_name == "แบบฟอร์มเยี่ยมบ้านผู้สูงอายุ") {
        this.$emit("viewForm", {
          value: {
            form_name: "แบบฟอร์มเยี่ยมบ้านผู้สูงอายุ"
          },
          item: item,
          type: "see",
        });
      } else if (item.form_name == "แบบฟอร์มเยี่ยมบ้านคลินิกอบอุ่น") {
        this.$emit("viewForm", {
          value: {
            form_name: "แบบฟอร์มเยี่ยมบ้านคลินิกอบอุ่น"
          },
          item: item,
          type: "see",
        });
      } else {
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ไม่พบตัวอย่างแบบฟอร์ม</span>",
          icon: "question",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    changePage(page) {
      this.page = page;
      this.getHomeVisitForm();
    },
  },
};
</script>

<style scoped>
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}

.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #ffffff;
  border-radius: 80px 0px 0px 0px;
}
.card-search {
  background: #ceefed;
  border-radius: 20px 5px;
}
.btn-add-document {
  background: #ceefed;
  border-radius: 20px 5px;
}

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.5rem !important;
}

::v-deep .v-select__selections {
  line-height: 25px;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}

::v-deep .v-data-table-header {
  background: #ceefed;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  border-collapse: separate;
  border-bottom: none;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #ceefed !important;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 80px !important;
}
</style>
